import React, { useEffect, useRef, useState } from 'react';
import PhysicsLayout from './PhysicsLayout';

const RotationBench = () => {
  const [shape, setShape] = useState('disk');
  const [m, setM] = useState(6);
  const [r, setR] = useState(0.18);
  const [tau, setTau] = useState(2.4);
  const canvasRef = useRef(null);
  const ang = useRef(0);

  const I = shape === 'hoop' ? m * r * r : 0.5 * m * r * r;
  const alpha = tau / I;

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let raf;
    let last = performance.now();
    const draw = (now) => {
      const dt = Math.min(0.04, (now - last) / 1000);
      last = now;
      ang.current += alpha * dt;
      const w = canvas.width;
      const h = canvas.height;
      ctx.fillStyle = '#0b1020';
      ctx.fillRect(0, 0, w, h);
      ctx.save();
      ctx.translate(w / 2, h / 2);
      ctx.rotate(ang.current);
      ctx.strokeStyle = '#a78bfa';
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.arc(0, 0, 70, 0, Math.PI * 2);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(70, 0);
      ctx.stroke();
      if (shape === 'disk') {
        ctx.globalAlpha = 0.15;
        ctx.fillStyle = '#a78bfa';
        ctx.beginPath();
        ctx.arc(0, 0, 70, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.restore();
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(raf);
  }, [alpha, shape]);

  return (
    <PhysicsLayout
      kicker="Bench 3 · shafts, rotors, flywheels"
      title="Torque & inertia"
      lead="Same motor torque. A thin hoop stores more I than a disk of equal mass and radius — so it accelerates less. This is every gearbox argument."
    >
      <div className="pp-split">
        <div>
          <label className="pp-field">Shape
            <select value={shape} onChange={(e) => setShape(e.target.value)} style={{ background: '#0b1220', color: '#fff', borderRadius: 10, padding: '0.45rem' }}>
              <option value="disk">Solid disk · I = ½ m r²</option>
              <option value="hoop">Thin hoop · I = m r²</option>
            </select>
          </label>
          <label className="pp-field">Mass {m} kg
            <input type="range" min="1" max="20" value={m} onChange={(e) => setM(+e.target.value)} />
          </label>
          <label className="pp-field">Radius {r.toFixed(2)} m
            <input type="range" min="0.05" max="0.4" step="0.01" value={r} onChange={(e) => setR(+e.target.value)} />
          </label>
          <label className="pp-field">Torque {tau.toFixed(1)} N·m
            <input type="range" min="0.2" max="8" step="0.1" value={tau} onChange={(e) => setTau(+e.target.value)} />
          </label>
        </div>
        <div>
          <div className="pp-stage"><canvas ref={canvasRef} width={520} height={260} /></div>
          <div className="pp-readout" style={{ marginTop: '0.8rem' }}>
            <p className="pp-eq">α = τ / I · I = {I.toFixed(3)} kg·m²</p>
            <strong>{alpha.toFixed(2)} rad/s²</strong>
            <p className="pp-note">Switch disk → hoop. Mass and radius stay put. The motor suddenly looks weak. That is inertia, not a broken drive.</p>
          </div>
        </div>
      </div>
    </PhysicsLayout>
  );
};

export default RotationBench;
